import { IconProps } from "./IconProps";

const Star: React.FC<IconProps> = ({
  width = 44,
  height = 44,
  color = "#FCFCFD",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 44 44" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8002 13.5825L26.0796 7.06678C24.4323 3.1216 18.8431 3.12164 17.1958 7.06678L14.4752 13.5825L7.41764 14.1461C3.14442 14.4874 1.41538 19.8235 4.67637 22.6061L10.0399 27.1827L8.40068 34.0281C7.40402 38.1901 11.9277 41.4858 15.5839 39.2613L21.6377 35.578L27.6915 39.2613C31.3477 41.4858 35.8714 38.1901 34.8747 34.0281L33.2355 27.1827L38.599 22.6061C41.86 19.8235 40.1309 14.4874 35.8577 14.1461L28.8002 13.5825Z"
        fill={color}
      />
    </svg>
  );
};
export default Star;
